import { IPanelTemplate } from '@llws/lift-entity-interfaces';
import { IApiListResponse } from '@llws/platform-shared-types/types/response/IApiResponse';
import { IQueryCommandOptions, convertQueryCommandToQueryString } from '@llws/dynamic-router-utils';
import {
  mergeQueryCommandOptionsV2,
} from '@/shared';
import { IAction } from '@/shared/interfaces/store-base';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';
import { IFilterPayloadV2 } from '../../shared/interfaces/filter-payload-v2';

type TPanelTemplateNamesAndKeys = Pick<IPanelTemplate, 'id' | 'name' | 'key'>;

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/panel_template';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  where: [],
};

const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [{ path: 'panelTemplateHasModels', alias: 'panelTemplateHasModels' }],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IPanelTemplate>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

const baseState = {
  ...base.state,
  panelTemplateNamesAndKeys: [] as TPanelTemplateNamesAndKeys[],
};

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'panel-templates/'
  state: baseState,

  getters: {
    ...base.getters,

    panelTemplateNamesAndKeys: (state: typeof baseState) => ([ ...state.panelTemplateNamesAndKeys ]),
  },

  mutations: {
    ...base.mutations,

    setPanelTemplateNamesAndKeys: (
      state: typeof baseState,
      payload: IApiListResponse<TPanelTemplateNamesAndKeys>,
    ) => {
      state.panelTemplateNamesAndKeys = payload.data ?? [];
    },
  },

  actions: {
    ...base.actions,

    getPanelTemplateNamesAndKeys: async (ctx: IAction<typeof baseState>, payload: IFilterPayloadV2) => {
      const command = mergeQueryCommandOptionsV2([
        defaultGetListFilters,
        payload.filters ?? {},
        { page: 1, limit: 9999, select: [ 'id', 'key', 'name' ] },
      ]);

      const response = await adminRequest.get<IApiListResponse<TPanelTemplateNamesAndKeys>>(
        `${adminGatewayResourcePath}${convertQueryCommandToQueryString(command)}`,
      );

      ctx.commit('setPanelTemplateNamesAndKeys', response);
    },
  },
};
